import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_1/5fd21a0f0f0639a690297ef6329cb2fc_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Middle',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "재능진로전공직업 탐색 프로젝트", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "PUTT2.0 기반 진로탐색 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "“청소년 문화공간을 건립하다!”")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-e8afe86a><dl data-v-e8afe86a><dt data-v-e8afe86a>목적</dt><dd data-v-e8afe86a> 본 활동은 학생이 자신의 꿈, 가치, 관심, 놀이 등을 실제 세상에 구현하기 위한 창작 활동으로, <br data-v-e8afe86a> 이 과정을 통해 재능 발견과 함께, 최적의 진로를 탐색하도록 하는 데 목적이 있다. </dd></dl><dl data-v-e8afe86a><dt data-v-e8afe86a>목표</dt><dd data-v-e8afe86a> 목표 1. (강의를 들으면서) 세상 이해 및 자기 이해를 통해 자기개념을 정립한다.<br data-v-e8afe86a> 목표 2. 팀별로, 평소에 관심이 있거나 재능을 발휘, 구현하고 싶은 문화공간을 검색, 조사, 제안, 논의, 선택한다.<br data-v-e8afe86a> 목표 3. 팀 구성원들이 재능을 발휘하여 성취를 경험할 수 있는 특정 문화공간을 설계, 건립 계획을 세운다. <br data-v-e8afe86a> 목표 4. 팀별로 ‘청소년 문화공간 건립 계획서’를 작성하여, 발표, 또래평가를 한다. </dd></dl><dl data-v-e8afe86a><dt data-v-e8afe86a>대상</dt><dd data-v-e8afe86a>중1 – 중3</dd></dl><dl class=\"line2\" data-v-e8afe86a><dt data-v-e8afe86a>시간</dt><dd data-v-e8afe86a>6시간 (사전 1시간ㅣ집합 5시간)</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-e8afe86a><ul class=\"line line4\" data-v-e8afe86a><li data-v-e8afe86a>JIGSAW 수업</li><li data-v-e8afe86a><dl class=\"line2\" data-v-e8afe86a><dt data-v-e8afe86a>재료</dt><dd data-v-e8afe86a> • 자료 1. 팀 구성: PUTT2.0 결과를 기반으로, 팀(4인1팀)을 구성(팀 내, 다양한 재능 유형으로), 명단을 조직<br data-v-e8afe86a> • 자료 2. (가상) 문화공간 건립 계획서 (Worksheet 1 – 4)<br data-v-e8afe86a> • 자료 3. 또래평가지: 다른 팀의 ‘문화공간 건립 계획서’ 평가에 사용할 ‘건립 계획서 평가지’ (Worksheet. 5) </dd></dl></li></ul></div><div data-v-e8afe86a><ul class=\"line\" data-v-e8afe86a><li data-v-e8afe86a> 결과물<br data-v-e8afe86a> + PUTT2.0 결과리포트<br data-v-e8afe86a> + 팀 과업 제안서 </li><li data-v-e8afe86a><dl class=\"line2\" data-v-e8afe86a><dt data-v-e8afe86a>구성</dt><dd data-v-e8afe86a> • 모듈 1. [사전 진단] PUTT2.0 - 1주일 전 - On-Line 실시 – 팀 배치<br data-v-e8afe86a> • 모듈 2. [강의] (1) PUTT2.0 결과 – 재능별/직업군별 사례 소개, (2) 과제 소개 및 안전 교육<br data-v-e8afe86a> • 모듈 3. [과제 수행] (1) 팀별 구성원(구성원 각자가 특정 분야 전문가임) 소개, (2) 문화공간 검색<br data-v-e8afe86a> (3) 공간 종류 및 개념/가치 설정, (4) 공간 개요/설계, (5) 구성원별 직무 및 조직 구성, 세부 내용 구성<br data-v-e8afe86a> • 모듈 4. [계획서 작성] 계획서 작성, 팀 발표, 또래평가 </dd></dl></li></ul></div><div data-v-e8afe86a><ul class=\"line\" data-v-e8afe86a><li data-v-e8afe86a>진행: 관리자</li><li data-v-e8afe86a><dl class=\"line2\" data-v-e8afe86a><dt data-v-e8afe86a>활용</dt><dd data-v-e8afe86a> “자유학기제”를 통해 학생의 타고난 재능에서 관심, 학습, 성취의지, 진로 선택까지 동일선상에서<br data-v-e8afe86a> 체계적, 총체적 데이터를 수집, 분석하여 이를 중장기적 학습 설계에 유용하게 활용할 수 있다. </dd></dl></li></ul></div>", 3)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})